import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatApiError } from "@/context/AuthContext";
import { toast } from "sonner";
import { Loader2, ShieldCheck, ArrowLeft } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError("Le due password non coincidono"); return; }
    setLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/reset-password`, { token, password });
      toast.success("Password aggiornata, ora puoi accedere");
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Errore, riprova.");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-sm bg-white border border-border p-8" data-testid="reset-password-page">
        <div className="w-10 h-10 bg-primary flex items-center justify-center"><ShieldCheck className="w-5 h-5 text-primary-foreground" /></div>
        <h1 className="font-heading font-black text-2xl tracking-tighter mt-4">Nuova password</h1>
        {!token ? (
          <p className="text-sm text-destructive mt-3" data-testid="reset-no-token">Link non valido: manca il token. Richiedi un nuovo reset dalla pagina di login.</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label className="data-label">Nuova password (min. 8 caratteri)</Label>
              <Input type="password" data-testid="reset-password-input" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} className="mt-1 rounded-none" placeholder="••••••••" />
            </div>
            <div>
              <Label className="data-label">Conferma password</Label>
              <Input type="password" data-testid="reset-confirm-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={8} className="mt-1 rounded-none" placeholder="••••••••" />
            </div>
            {error && <div data-testid="reset-error" className="text-sm text-destructive border border-destructive/30 bg-destructive/5 px-3 py-2">{error}</div>}
            <Button type="submit" data-testid="reset-submit-btn" disabled={loading} className="w-full rounded-none font-medium">
              {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Imposta nuova password
            </Button>
          </form>
        )}
        <Link to="/login" className="mt-6 inline-flex items-center gap-1 text-sm text-primary hover:underline" data-testid="back-to-login-link">
          <ArrowLeft className="w-3.5 h-3.5" /> Torna al login
        </Link>
      </div>
    </div>
  );
}
